// extracted by mini-css-extract-plugin
export default {"container":"TipResultDot_container__hqG7o"};